import { Routes } from '@angular/router';
import { AUTH_ROUTES } from './core/auth/auth.routes';
import { roleGuard } from './core/guards/role.guard';
import { subscriptionGuard } from './core/guards/subscription.guard';
import { templateEditorGuard } from './core/guards/template-editor.guard';
import { UserRole } from './core/api';
import { AppShellComponent } from './shared/components/app-shell/app-shell.component';
import { SubscriptionExpiredComponent } from './features/subscription-expired/subscription-expired.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/main/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    children: AUTH_ROUTES
  },
  {
    path: 'main',
    component: AppShellComponent,
    canActivate: [roleGuard([UserRole.Admin, UserRole.Assistant, UserRole.Consultant, UserRole.Owner])],
    // canActivateChild, not canActivate: a parent's canActivate only runs when that parent is activated, so
    // moving between /main children would never re-check and a user already inside the app could keep
    // navigating after their subscription lapsed. Resolving /main to 'dashboard' is itself a child
    // activation, so entry is covered too — and it runs once per navigation rather than twice.
    canActivateChild: [subscriptionGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((mod) => mod.DASHBOARD_ROUTES)
      },
      {
        path: 'clients',
        loadChildren: () => import('./features/clients/clients.routes').then((mod) => mod.CLIENTS_ROUTES)
      },
      {
        path: 'tax-due-date-management',
        loadChildren: () =>
          import('./features/tax-due-date-management/tax-due-date-management.routes').then((mod) => mod.TAX_DUE_DATE_MANAGEMENT_ROUTES)
      },
      {
        path: 'notifications',
        canActivate: [roleGuard([UserRole.Owner, UserRole.Admin]), templateEditorGuard],
        loadChildren: () => import('./features/notifications/notifications.routes').then((mod) => mod.NOTIFICATIONS_ROUTES)
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then((mod) => mod.SETTINGS_ROUTES)
      }
    ]
  },
  {
    path: 'subscription-expired',
    canActivate: [roleGuard([])],
    component: SubscriptionExpiredComponent
  },
  {
    path: 'dev',
    loadChildren: () => import('./features/dev/dev.routes').then((mod) => mod.DEV_ROUTES)
  }
];
